import { useQuery } from '@tanstack/react-query';

const DOWNLOAD_FILE_KEY = 'downloadFile';
/*
 * Generic hook to download a file blob from a signed URL.
 * Use enabled flag to control when to fetch the blob with more control than just the presence of the signed URL.
 */
export const useGetBlobFileFromStorage = (
  signedUrl: string | null,
  enabled = true,
) => {
  return useQuery({
    queryKey: [DOWNLOAD_FILE_KEY, signedUrl],
    queryFn: async () => {
      if (!signedUrl) throw new Error('No signed URL provided');

      try {
        // use regular fetch as authentication is handled via signed URL instead of axios instance
        const response = await fetch(signedUrl);
        if (!response.ok) {
          throw new Error(`Failed to fetch file: ${response.statusText}`);
        }

        return await response.blob();
      } catch (error) {
        if (error instanceof Error) {
          throw new Error(`Failed to download file: ${error.message}`);
        }
        throw new Error('Failed to download file: Unknown error');
      }
    },
    enabled: enabled && !!signedUrl,
  });
};
